/**
 * components/labelArt.ts — the pictures of the record's faces and of the 45's adapters, by kind.
 *
 * The kinds and which adapter suits which label are `lib/labels.ts`'s; this is where each kind
 * meets its built file. One import per picture: the build hashes every file and serves it with a
 * year of cache (`assetsInlineLimit: 0`), so a label is one request the first time it turns up.
 */

import adapterBoltUrl from '../assets/adapter-bolt.svg';
import adapterChromeUrl from '../assets/adapter-chrome.svg';
import adapterFlagUrl from '../assets/adapter-flag.svg';
import adapterPalmUrl from '../assets/adapter-palm.svg';
import adapterSpiderUrl from '../assets/adapter-spider.svg';
import gold33Url from '../assets/label-gold-33.svg';
import gold45Url from '../assets/label-gold-45.svg';
import industrial33Url from '../assets/label-industrial-33.svg';
import industrial45Url from '../assets/label-industrial-45.svg';
import isle33Url from '../assets/label-isle-33.svg';
import isle45Url from '../assets/label-isle-45.svg';
import jamaica33Url from '../assets/label-jamaica-33.svg';
import jamaica45Url from '../assets/label-jamaica-45.svg';
import night33Url from '../assets/label-night-33.svg';
import night45Url from '../assets/label-night-45.svg';
import noon33Url from '../assets/label-noon-33.svg';
import noon45Url from '../assets/label-noon-45.svg';
import rings33Url from '../assets/label-rings-33.svg';
import rings45Url from '../assets/label-rings-45.svg';
import roots33Url from '../assets/label-roots-33.svg';
import roots45Url from '../assets/label-roots-45.svg';
import soundsystem33Url from '../assets/label-soundsystem-33.svg';
import soundsystem45Url from '../assets/label-soundsystem-45.svg';
import studio33Url from '../assets/label-studio-33.svg';
import studio45Url from '../assets/label-studio-45.svg';
import sunset33Url from '../assets/label-sunset-33.svg';
import sunset45Url from '../assets/label-sunset-45.svg';
import tropic33Url from '../assets/label-tropic-33.svg';
import tropic45Url from '../assets/label-tropic-45.svg';
import type { AdapterKind, LabelKind } from '../lib/labels';
import type { RecordSize } from '../lib/records';

/** Each label's picture on each record. */
export const LABEL_ART: Readonly<Record<LabelKind, Readonly<Record<RecordSize, string>>>> = {
  jamaican: { '33': jamaica33Url, '45': jamaica45Url },
  soundsystem: { '33': soundsystem33Url, '45': soundsystem45Url },
  rings: { '33': rings33Url, '45': rings45Url },
  industrial: { '33': industrial33Url, '45': industrial45Url },
  studio: { '33': studio33Url, '45': studio45Url },
  roots: { '33': roots33Url, '45': roots45Url },
  sunset: { '33': sunset33Url, '45': sunset45Url },
  night: { '33': night33Url, '45': night45Url },
  noon: { '33': noon33Url, '45': noon45Url },
  tropic: { '33': tropic33Url, '45': tropic45Url },
  isle: { '33': isle33Url, '45': isle45Url },
  gold: { '33': gold33Url, '45': gold45Url },
};

/** Each adapter's picture: on the 45's hole, or waiting in the deck's holder at 33. */
export const ADAPTER_ART: Readonly<Record<AdapterKind, string>> = {
  flag: adapterFlagUrl,
  chrome: adapterChromeUrl,
  spider: adapterSpiderUrl,
  palm: adapterPalmUrl,
  bolt: adapterBoltUrl,
};
